import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GatewayPass } from 'src/features/gatewayPass/types';

const RESOURCE = `sp-core/:parkingId/visitors/gateway-pass/:gatewayPassId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    gatewayPassId: string;
}
const queryFn = ({ parkingId, gatewayPassId }: DTO): Promise<GatewayPass> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, gatewayPassId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetGatewayPass };
